<template>
    <div class="person_page" ref="middle_page">
        <div class="person_main">
            <span class="personPage_span"></span>
            <div class="manage--content_info" v-if="user_info != null">
                <div class="nav_content_info_user" v-if="itemUpdate==0">
                    <table>
                        <tr>
                            <td>
                                <img class="user_photo" :src="headImagePath" @click="edit_head_image()" @error="setAltStudent"/>
                            </td>
                            <td class="name_header">
                                <p class="user_name_header">{{user_info.userName}}</p>
                                <p class="introduce_header">
                                    <span>{{$t("personSet.synopsisUser")}}: </span>
                                    <span v-if="user_info.studentSynopsis" v-html="studentSynopsisUser"></span>
                                    <span v-else>{{$t("personSet.synopsisNonUser")}}</span>
                                </p>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="tab" v-if="itemUpdate==0">
                    <button class="btn-tab" :class="{active1: item=='personInfo'}" v-on:click="item ='personInfo';">{{$t("personSet.personInfo")}}</button>
                    <button class="btn-tab" :class="{active1: item=='changePass'}" v-on:click="item ='changePass';">{{$t("personSet.changePass")}}</button>
                </div>
                <detailsUser :data="user_info" v-if="item=='personInfo'" v-on:changeItem="changeItem($event)" v-on:updateInfoUser="updateInfoUser($event)" v-on:getInfoCurrent="getInfoCurrent($event)" v-on:checkGenderUser="checkGenderUser($event)"></detailsUser>
                <changerPass v-if="item=='changePass'" v-on:backPageDetails="backPageDetails($event)"></changerPass>
            </div>
        </div>
        <el-dialog
            class="home_dialog_page report"
            :visible.sync="img_show"
            width="30%"
            :modal="true"
            :show-close="false"
        >
            <div class="dialog_page_main distance_top_30">
                <div class="dialog_page_title">
                    <p>{{ $t("personSet.changeFace") }}</p>
                </div>
                <div class="dialog_page_content">
                    <div class="img-container">
                        <vueCropper
                            ref="cropper"
                            :img="option.img"
                            :outputSize="option.size"
                            :outputType="option.outputType"
                            :info="true"
                            :full="option.full"
                            :canMove="option.canMove"
                            :canMoveBox="option.canMoveBox"
                            :fixedBox="option.fixedBox"
                            :original="option.original"
                            :autoCrop="option.autoCrop"
                            :autoCropWidth="option.autoCropWidth"
                            :autoCropHeight="option.autoCropHeight"
                            :centerBox="option.centerBox"
                            :high="option.high"
                            :infoTrue="option.infoTrue"
                            :maxImgSize="option.maxImageSize"
                            @realTime="realTime"
                            @imgLoad="imgLoad"
                            @cropMoving="cropMoving"
                            :enlarge="option.enlarge"
                            :mode="option.mode"
                        ></vueCropper>
                    </div>
                    <div class="docs-preview" style="height:50px">
                        <div>
                            <label class="file" for="uploads">
                                {{$t("personSet.chooseImg")}}
                            </label>
                            <input
                                type="file"
                                id="uploads"
                                style="position:absolute; clip:rect(0 0 0 0);"
                                accept="image/png, image/jpeg, image/gif, image/jpg"
                                @change="uploadImg($event, 1)"
                            />
                        </div>
                        <div v-if="option.img" class="img-rotate">
                            <img
                                src="../../../static/images/icon-rotate-left.png"
                                @click="rotateLeft()"
                            />
                            <img
                                src="../../../static/images/icon-rotate-right.png"
                                @click="rotateRight()"
                            />
                        </div>
                    </div>
                    <div class="docs-preview docs-preview-new">
                        <div :style="previewStyle1">
                            <div :style="previews.div">
                                <img :src="previews.url" :style="previews.img" />
                            </div>
                        </div>
                    </div>
                </div>
                <el-row>
                    <el-button round class="form_btn" @click="upload_head_image()">
                        {{$t("personSet.save")}}
                    </el-button>
                    <el-button round class="form_btn" @click="img_show = false">
                        {{$t("personSet.off")}}
                    </el-button>
                </el-row>
            </div>
        </el-dialog>
        <loading :showLoading="showLoadingFlg" />
    </div>
</template>

<script>
import VueCropper from "vue-cropper/src/vue-cropper";
import loading from "@/components/loading/loading";
import detailsUser from "@/components/personSet/infoUser/userDetails";
import changerPass from "@/components/personSet/infoUser/changerPass";
import md5 from "js-md5";
export default {
    name: "personSet",
    components: {
        detailsUser,
        changerPass,
        VueCropper,
        loading
    },
    data() {
        return {
            user_info: null,
            user_info_current: null,
            activeTab: 1,
            itemUpdate: 0,
            showLoadingFlg: false,
            img_show: false,
            userId: null,
            role: null,
            item: "personInfo",
            message_number: 0,
            messageContent: null,
            receiptInfo: {},
            name: null,
            headImagePath: null,
            editImagePath: "",
            pageInfo: {
                pageNum: 1
            },
            model: false,
            modelSrc: "",
            crap: false,
            previews: {},
            previewStyle1: {},
            option: {
                img: "",
                size: 1,
                full: true,
                outputType: "png",
                canMove: true,
                fixedBox: true,
                fixed: true,
                fixedNumber: [1, 1],
                original: false,
                canMoveBox: true,
                canScale: false,
                autoCrop: true,
                autoCropWidth: 200,
                autoCropHeight: 200,
                centerBox: false,
                high: true,
                cropData: {},
                enlarge: 1,
                mode: "contain",
                maxImgSize: 2000,
                zoomable: false,
                mouseWheelZoom: false,
                wheelZoomRatio: 0 
            },
            downImg: "#",
            certificateInfo: {
                realName: "",
                authenticationState: 0,
                auditFailureReason: "",
                authenticationFilePathList: [],
                userId: ""
            },
            clickIndexMessage: false,
            studentSynopsisUser: "",
        };
    },
    beforeCreate() {
        document.documentElement.scrollTop = 0;
    },
    created() {
        this.$autoLogin().then(
        async () => {
            /// check trường hợp email có tồn tại hay không
            let rToken = window.sessionStorage.getItem("email");
            if(rToken === null) {
                this.$el_alert_type(window.vm.$i18n.t("js.PleaseLogin"),'warning');
                window.sessionStorage.clear();
                this.$router.push("/");
                window.location.reload();
                return;
            }
            /// lấy data API thông tin user
            this.showLoadingFlg = true;
            let result = await this.getPageInfoUser();
            this.showLoadingFlg = false;
            // data ok
            if (result.meta.success) {
                this.user_info = result.data;
                let studentSynopsisUS = this.user_info.studentSynopsis;
                if (studentSynopsisUS) {
                    this.studentSynopsisUser = studentSynopsisUS.replace(/\n/g, '</br>');
                }
            } else {
                // data lỗi
                this.$el_alert_type(window.vm.$i18n.t("js.PleaseLogin"),'warning');
                this.$el_alert_type(window.vm.$i18n.t("js.PleaseLogin"),'warning');
                window.sessionStorage.clear();
                this.$router.push("/");
                window.location.reload();
                return;
            }
            const that = this;
            // check trường hợp chưa thay đổi pass sẽ hiển thị dialog và di chuyển sang trang thay đổi pass
            if (window.sessionStorage.getItem("passwordChangeFlag")==0
                &&window.sessionStorage.getItem("confirmPasswordChangeFlagFirst")==null
            ){
            that.item = "changePass";
            this.$alert(window.vm.$i18n.t("new.title17"), "", {
                confirmButtonText: window.vm.$i18n.t("js.confirm"),
                type:"warning",
                dangerouslyUseHTMLString:true
            });
            window.sessionStorage.setItem("confirmPasswordChangeFlagFirst", "true");
            } else {
            if (that.$route.query.clickIndexMessage === 1){
                that.item = "message";
            } else {
                that.item = "personInfo";
            }
            }
            that.userId = window.sessionStorage.getItem("id");
            that.certificateInfo.userId = that.userId;
            that.role = window.sessionStorage.getItem("role");
            that.name = window.sessionStorage.getItem("name");
            if (window.sessionStorage.getItem("headImagePath")) {
            that.headImagePath = window.sessionStorage.getItem("headImagePath");
            that.editImagePath = window.sessionStorage.getItem("headImagePath");
            } else {
                if (parseInt(this.user_info.gender)==2) {
                    that.headImagePath = "static/images/SA-ava-nu.png";
                } else {
                    that.headImagePath = "static/images/profile.jpg";
                }
            }
            that.companyId = window.sessionStorage.getItem("companyId");
        },
        () => {
            this.$router.push({
            path: "/home"
            });
        }
        );
    },
    methods: {
        /// Lấy thông tin user
        getPageInfoUser: async function(){
            return new Promise((resolve, reject) => {
                this.showLoadingFlg = true;
                this.$api
                .post("/personalCenter/getPersonalInfo", {
                    rToken:md5(window.sessionStorage.getItem("email")),
                    languageType:this.$lang(),
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((err) => {
                    reject(err.response);
                });
            });
        },
         setAltStudent(event) { 
            event.target.src = "../../../static/images/profile.jpg" ;
         },
        /// Gọi nút trang chi tiết
        changeItem: function (params) {
            this.itemUpdate = params;
        },
        /// Lấy thông tin cũ khi nhấn nút chỉnh sửa
        getInfoCurrent: function (params) {
            if (params) {
                /// Lấy data cũ
                this.$api.post("/personalCenter/getPersonalInfo", {
                    rToken:md5(window.sessionStorage.getItem("email")),
                    languageType:this.$lang(),
                })
                .then((response) => {
                    this.user_info_current = response.data;
                })
                .catch((err) => {});
            }
        },
        /// Back lại data cũ khi nhấn nút huỷ
        updateInfoUser: function (params) {
            if (!params) {
                this.user_info = this.user_info_current;
                let studentSynopsisUS = this.user_info.studentSynopsis;
                if (studentSynopsisUS) {
                    this.studentSynopsisUser = studentSynopsisUS.replace(/\n/g, '</br>');
                }
            } else {
                let studentSynopsisUS = this.user_info.studentSynopsis;
                if (studentSynopsisUS) {
                    this.studentSynopsisUser = studentSynopsisUS.replace(/\n/g, '</br>');
                }
            }
        },
        /// Quay lại trang chi tiết khi update thành công pass
        backPageDetails: function (params) {
            this.item = params;
        },
        /// Xoay ảnh bên trái
        rotateLeft() {
        this.$refs.cropper.rotateLeft();
        },
        /// Xoay ảnh bên phải
        rotateRight() {
        this.$refs.cropper.rotateRight();
        },
        /// Set độ dài ảnh
        realTime(data) {
            var previews = data;
            var h = 0.5;
            var w = 0.2;
            this.previewStyle1 = {
                width: previews.w + "px",
                height: previews.h + "px",
                overflow: "hidden",
                margin: "0 auto",
                zoom: h
            };
            this.previewStyle2 = {
                width: previews.w + "px",
                height: previews.h + "px",
                overflow: "hidden",
                margin: "0",
                zoom: w
            };
            this.previewStyle3 = {
                width: previews.w + "px",
                height: previews.h + "px",
                overflow: "hidden",
                margin: "0",
                zoom: 100 / previews.w
            };
            this.previewStyle4 = {
                width: previews.w + "px",
                height: previews.h + "px",
                overflow: "hidden",
                margin: "0",
                zoom: 100 / previews.h
            };
            this.previews = data;
        },
        /// Upload hình ảnh
        uploadImg(e, num) {
            var file = e.target.files[0];
            if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
                this.$message.warning(window.vm.$i18n.t("personSet.imageError"));
                return false;
            }
            var reader = new FileReader();
            reader.onload = e => {
                let data;
                if (typeof e.target.result === "object") {
                data = window.URL.createObjectURL(new Blob([e.target.result]));
                } else {
                data = e.target.result;
                }
                if (num === 1) {
                this.option.img = data;
                } else if (num === 2) {
                this.example2.img = data;
                }
            };
            reader.readAsArrayBuffer(file);
        },
        /// data trong vueCropper
        imgLoad(msg) {},
        /// data trong vueCropper
        cropMoving(data) {
        this.option.cropData = data;
        },
        /// Lưu hình ảnh
        upload_head_image: function() {
            this.showLoadingFlg = true;
            this.$refs.cropper.getCropData(data => {
                this.$api
                .post("/personalCenter/updatePersonalHeadImage", {
                    headImageFile: data.toString()
                })
                .then(response => {
                    this.headImagePath = response.data;
                    this.editImagePath = response.data;
                    window.sessionStorage.setItem("headImagePath", response.data);
                    this.img_show = false;
                    this.$el_alert_type(
                    window.vm.$i18n.t("personSet.imgSuccess"),
                    "success"
                    );
                    this.showLoadingFlg = false;
                    this.$emit("edit-head-image", this.headImagePath);
                });
            });
        },
        /// click chỉnh sửa hình ảnh
        edit_head_image: function() {
            this.img_show = true;
            this.model = false;
            this.modelSrc = "";
            this.crap = false;
            this.previews = {};
            this.previewStyle1 = {};
            let option = {
                img: this.editImagePath,
                size: 1,
                full: true,
                outputType: "png",
                canMove: true,
                fixedBox: true,
                fixed: true,
                fixedNumber: [1, 1],
                original: false,
                canMoveBox: true,
                canScale: false,
                autoCrop: true,
                autoCropWidth: 200,
                autoCropHeight: 200,
                centerBox: false,
                high: true,
                cropData: {},
                enlarge: 1,
                mode: "contain",
                maxImgSize: 2000,
                zoomable: false,
                mouseWheelZoom: false,
                wheelZoomRatio: 0
            };
            this.option = option;
            this.downImg = "#";
        },
        checkGenderUser(params) {
            if (!window.sessionStorage.getItem("headImagePath")) {
                if (parseInt(params)==2) {
                    this.headImagePath = "static/images/SA-ava-nu.png";
                } else {
                    this.headImagePath = "static/images/profile.jpg";
                }
            }
        }
    }
};
</script>
<style scoped="scoped">
@import "../../../static/css/personSet.css";
.nav_content_info_user .user_photo {
  width: 100px;
  height: 100px;
  /* position: absolute; */
  margin-top: 5px;
  margin-left: 5px;
  margin-bottom: 15px;
  border-radius: 50%;
  border: 2px #fff solid;
  cursor: pointer;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.45);
}
.name_header {
    vertical-align:top;
    padding-left: 15px;
}
.name_header .user_name_header {
    font-size: 18px;
    font-weight: 700;
    color: #0071c5;
    margin-top: 5px;
}
.name_header .introduce_header {
    margin-top: 10px;
    color: #9b9c98;
}
.person_page{
  /* background: linear-gradient(57deg,#e4e2ea,#0eb8cc)!important; */
}
.person_page {
  width: 100%;
  height: 100%;
  background-color: rgb(100, 101, 112);
  background: url(../../../static/images/bg/personset_bg2.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}

.personPage_span {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.nav_content {
  width: 30%;
  min-height: 200px;
  margin-top: 150px;
  float: left;
  position: relative;
}

.nav_content .user_photo {
  width: 100px;
  height: 100px;
  position: absolute;
  margin-top: -52px;
  border-radius: 50%;
  margin-left: calc(50% - 50px);
  border: 2px #fff solid;
  cursor: pointer;
}

.nav_content .nav_content_box {
  min-height: 200px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 15px;
}

.nav_content .nav_content_box .user_name {
  height: 20px;
  margin: 0 auto;
  padding-top: 70px;
  padding-bottom: 10px;
  font-size: 15px;
  color: #e8e6e6;
  text-align: center;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.nav_content .nav_content_box .identification_btn {
  width: 180px;
  margin: 0 auto;
  text-align: center;
  border-bottom: 1px rgba(65, 65, 65, 1) solid;
}

.nav_content .nav_content_box .identification_btn button {
  padding: 2px 10px 4px 10px;
  margin-bottom: 10px;
  background-color: unset;
  font-size: 12px;
  color: #fff;
  border-radius: 10px;
  border: 1px #fff solid;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
}

.nav_content .nav_content_box .identification_btn button:hover {
  background-color: #323232;
  transition: 0.5s ease;
}

.nav_content .nav_content_box ul {
  width: 100%;
  overflow: hidden;
  zoom: 1;
  padding-bottom: 20px;
  margin-top: 10px;
}

.nav_content .nav_content_box ul li {
  width: 100%;
  height: 48px;
  line-height: 48px;
  display: block;
  text-align: center;
}

.nav_content .nav_content_box ul li p {
  width: auto;
  font-size: 14px;
  color: #c7c7c7;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}
.nav_content .nav_content_box ul li p span {
  font-size: 14px;
  color: #c7c7c7;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.nav_content .nav_content_box ul li p span:hover {
  cursor: pointer;
  color: #fff;
}

.nav_content .nav_content_box ul li .message_span {
  width: 18px;
  line-height: 18px;
  height: 18px;
  background: #ff5252;
  color: #fff;
  font-size: 12px;
  border-radius: 100%;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  position: absolute;
  z-index: 100;
  margin-top: -42px;
  margin-left: 25px;
}

.nav_content_item_active p span {
  font-weight: bold;
  font-family: museo-slab-w01-100, serif;
  color: #fff !important;
}

.person_components {
  width: 100%;
  min-height: 200px;
  margin-top: 50px;
  float: right;
  position: relative;
}

.dialog_page_main {
  width: 85%;
  min-height: 200px;
  margin: 0 auto;
  background-color: rgba(50, 50, 50, 1);
  border-radius: 20px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
}

.dialog_page_title {
  position: relative;
  padding-top: 20px;
}

.dialog_page_title p {
  min-width: 260px;
  overflow: hidden;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.dialog_page_content {
  padding: 20px;
}

.dialog_page_content > .img-container {
  border: solid 1px #000000;
  background-color: #ffffff;
  height: 300px;
}

.dialog_page_content > .img-container > img {
  height: 100%;
}

.docs-preview {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  height: 200px;
}

.img-preview {
  width: 120px;
  height: 120px;
  background-color: #fff;
  border: solid 1px #000000;
}

.docs-preview .file {
  width: 100px;
  height: 30px;
  line-height: 30px;
  background-color: unset;
  font-size: 12px;
  color: #fff;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  border: 1px #fff solid;
  padding: 0;
  text-align: center;
  border-radius: 20px;
  position: relative;
  cursor: pointer;
  transition: 0.5s ease;
}
.docs-preview .file:hover {
  background-color: #fff;
  color: #000;
  transition: 0.5s ease;
}

.docs-preview .file #inputImage {
  position: absolute;
  width: 100px;
  right: 0;
  opacity: 0;
}

.form_btn {
  margin-bottom: 20px;
  background-color: unset;
  font-size: 12px;
  color: #fff;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  border: 1px #fff solid;
  padding: 9px 27px !important;
  transition: 0.5s ease;
}

.form_btn:hover {
  background-color: #fff;
  color: #000;
  transition: 0.5s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/personSet/contentInfoUser.vue